import BrandSummaryIcon from '../../../assets/icons/menu/brand-summary.svg';
import CustomerAnalysisIcon from '../../../assets/icons/menu/customer-analysis.svg';
import PPCIcon from '../../../assets/icons/menu/ppc.svg';
import ProductLevelIcon from '../../../assets/icons/menu/product-level.svg';
import PromotionsIcon from '../../../assets/icons/menu/promotions.svg';
import QuantitativeReport from '../../../assets/icons/menu/quantitative-report.svg';
import ResellersIcon from '../../../assets/icons/menu/reseller.svg';
import TrafficConversionIcon from '../../../assets/icons/menu/trafic-conversion.svg';
import MarketIntelligence from '../../../assets/icons/svg/market-share-report.svg';
import type { ISidebarNav } from './types';

export const fullMenuItems: ISidebarNav[] = [
  {
    key: 'brand-summary',
    title: 'Performance Center',
    link: '/performance/center',
    icon: BrandSummaryIcon,
  },
  // {
  //   key: 'timeline-overview',
  //   title: 'Timeline Overview',
  //   link: '/brand/timeline',
  //   icon: renderNavIcon(Timeline, 'Timeline'),
  // },
  {
    key: 'traffic-conversions',
    title: 'Traffic & Conversions',
    link: '/brand/traffic',
    icon: TrafficConversionIcon,
  },
  {
    key: 'reseller',
    title: 'Resellers',
    icon: ResellersIcon,
    children: [
      {
        key: 'bbx',
        title: 'Buy Box Central',
        link: '/ppc/resellers/buybox',
      },
      // {
      //     key: "reseller-central",
      //     title: "Reseller Central",
      //     link: "/",
      // },
      // {
      //     key: "reseller-matching",
      //     title: "Reseller Matching",
      //     link: "/",
      // },
    ],
  },
  {
    key: 'product-level',
    title: 'Product Level',
    icon: ProductLevelIcon,
    children: [
      {
        key: 'product-performance',
        title: 'Product Performance',
        link: '/performance/products',
      },
      {
        key: 'category-performance',
        title: 'Category Performance',
        link: '/performance/category',
      },
      {
        key: 'bundles',
        title: 'Bundles',
        link: '/performance/bundles',
      },
    ],
  },
  {
    key: 'promotions',
    title: 'Promotions',
    icon: PromotionsIcon,
    children: [
      {
        key: 'promo-reports',
        title: 'Promotional Reporting',
        link: '/promotions/reports',
      },
      {
        key: 'sns',
        title: 'Subscribe & Save',
        link: '/performance/sns',
      },
    ],
  },
  {
    key: 'ppc',
    title: 'PPC',
    icon: PPCIcon,
    children: [
      {
        key: 'ppc-overview',
        title: 'Overview',
        link: '/ppc/overview',
      },
      {
        key: 'ppc-timeline',
        title: 'Timeline',
        link: '/ppc/timeline',
      },
      {
        key: 'customer-journey',
        title: 'Customer Journey',
        link: '/ppc/journey',
      },
      {
        key: 'products-x-campaign',
        title: 'Products x Campaign',
        link: '/ppc/products',
      },
      {
        key: 'keyword-analysis',
        title: 'Keyword Analysis',
        link: '/ppc/keywords/analysis',
      },
      // {
      //     key: "paid-media",
      //     title: "Paid Media Summary",
      //     link: "/ppc/paid-media",
      // },
      // {
      //     key: "new-keyword-cloud",
      //     title: "New Keyword Cloud",
      //     link: "/ppc/keywords/cloud",
      // },
    ],
  },
  {
    key: 'customer-analysis',
    title: 'Customer Analysis',
    icon: CustomerAnalysisIcon,
    children: [
      {
        key: 'customer-geography',
        title: 'Customer Geography',
        link: '/customer/geography',
      },
      // {
      //     key: "customer-lifetime-value",
      //     title: "Customer Lifetime Value",
      //     link: "/customer/clv",
      // },
      // {
      //     key: "auto-roas",
      //     title: "Auto ROAS",
      //     link: "/",
      // },
      // {
      //     key: "product-pairing-analysis",
      //     title: "Product Pairing Analysis",
      //     link: "/",
      // },
      // {
      //     key: "reviews",
      //     title: "Reviews",
      //     link: "/",
      // },
    ],
  },
  {
    key: 'market-intelligence',
    title: 'Market Intelligence',
    icon: MarketIntelligence,
    children: [
      {
        key: 'market-share',
        title: 'Market Share',
        link: '/market-intelligence/share',
      },
      {
        key: 'report-builder',
        title: 'Report Builder',
        link: '/market-share/report-builder',
      },
    ],
  },

  // {
  //     key: "brand-report",
  //     title: "Brand Report",
  //     link: "/brand/report",
  //     icon: renderNavIcon(Brand, "Brand Report"),
  // },
  {
    key: 'quantitative-report',
    title: 'Quantitative Report',
    link: '/brand/quantitative',
    icon: QuantitativeReport,
  },
];
